import BustypeResource from "./bustype.resource";

const bustypeModule = angular
  .module("app.resources.bustype", [])
  .service("Bustype", BustypeResource);

export default bustypeModule;



// WEBPACK FOOTER //
// ./src/resources/bustype/bustype.module.js